import { Homes } from '@assets/icons/categories/homes'
import { Igloo } from '@assets/icons/igloo'
import { BasketballCourt } from '@assets/icons/spaces/basketball-court'
import { LargeBackyard } from '@assets/icons/spaces/large-backyard'
import { Pickleball } from '@assets/icons/spaces/pickleball'
import { Pool } from '@assets/icons/spaces/pool'
import { TennisCourt } from '@assets/icons/spaces/tennis-court'
import { brandColors } from '@components/layout/colors/brand-colors.css'
import { ListingType } from '@libs/graphql/types'

const typeAccentColors: Partial<
  Record<ListingType, React.CSSProperties['backgroundColor']>
> = {
  [ListingType.basketballCourt]: brandColors.hoopsOrange,
  [ListingType.largeBackyard]: brandColors.yardGreen,
  [ListingType.pickleball]: brandColors.darkBlue,
  [ListingType.pool]: brandColors.primaryBlue,
  [ListingType.tennisCourt]: brandColors.tennisGreen,
  [ListingType.home]: brandColors.primaryBlue,
  [ListingType.igloo]: brandColors.darkBlue,
}

const typeIcons: Partial<Record<ListingType, SvgIconComponent>> = {
  [ListingType.basketballCourt]: BasketballCourt,
  [ListingType.largeBackyard]: LargeBackyard,
  [ListingType.pickleball]: Pickleball,
  [ListingType.pool]: Pool,
  [ListingType.tennisCourt]: TennisCourt,
  [ListingType.home]: Homes,
  [ListingType.igloo]: Igloo,
}

const typeArenas: Partial<Record<ListingType, string>> = {
  [ListingType.basketballCourt]: 'court',
  [ListingType.largeBackyard]: 'yard',
  [ListingType.other]: 'space',
  [ListingType.pool]: 'pool',
  [ListingType.pickleball]: 'court',
  [ListingType.tennisCourt]: 'court',
  [ListingType.dockedBoat]: 'boats',
  [ListingType.home]: 'home',
  [ListingType.disney]: 'swimming pool',
  [ListingType.simply]: 'swimming pool',
  [ListingType.igloo]: 'igloo',
}

const typeVerbs: Partial<Record<ListingType, string>> = {
  [ListingType.basketballCourt]: 'play',
  [ListingType.largeBackyard]: 'visit',
  [ListingType.other]: 'visit',
  [ListingType.pool]: 'swim',
  [ListingType.pickleball]: 'play',
  [ListingType.tennisCourt]: 'play',
  [ListingType.home]: 'visit',
  [ListingType.igloo]: 'swim',
}

const typeOpenFor: Partial<Record<ListingType, string>> = {
  [ListingType.basketballCourt]: 'play',
  [ListingType.largeBackyard]: 'business',
  [ListingType.other]: 'business',
  [ListingType.pool]: 'swimming',
  [ListingType.pickleball]: 'play',
  [ListingType.tennisCourt]: 'play',
  [ListingType.home]: 'business',
  [ListingType.igloo]: 'swimming',
}

export const listingConstants = {
  typeAccentColors,
  typeIcons,
  typeArenas,
  typeVerbs,
  typeOpenFor,
}
